export default function ({ route, redirect }) {
    // Add logic to handle unwanted navigation
    // For example, prevent navigation to a specific route
    if (route.path === '/profile/driver' || route.path === '/profile/passenger') {
        return redirect('/');
    }
}